import React from 'react';
import { ShieldCheck, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';

export const HouseRules = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <div className="pb-8 border-b">
      <h2 className="text-2xl font-semibold mb-4 text-gray-900 flex items-center gap-2">
        <ShieldCheck className="h-6 w-6" />
        {t.rulesTitle}
      </h2>
      
      <div className="space-y-3 mb-4">
        {t.rules.map((rule, index) => (
          <div key={index} className="flex items-start gap-3 py-2">
            <Clock className="h-4 w-4 text-gray-400 flex-shrink-0 mt-1" />
            <span className="text-gray-700">{rule}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
